import { distance as findDistance } from 'fastest-levenshtein';

import { getMinAgeByCountry } from '@/helpers/conf';

export const days = Array.apply(null, Array(31)).map((_, index) => {
  const day = index + 1;
  const dayFull = day > 9 ? `${day}` : `0${day}`;

  return {
    name: dayFull,
    value: dayFull,
  };
});

export const months = Array.apply(null, Array(12)).map((_, index) => {
  const month = index + 1;

  return {
    name: month,
    value: (month > 9 ? `${month}` : `0${month}`).toString(),
  };
});

export const getYears = (countryCode?: string) => {
  const currentFullYear = new Date().getFullYear();
  const decrement = getMinAgeByCountry(countryCode);
  const currentYear = currentFullYear - decrement;

  return Array.apply(null, Array(100)).map((_, index) => {
    const year = (Number(currentYear) - index).toString();

    return {
      name: year,
      value: year,
    };
  });
};

export const EMAIL_DOMAINS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'yahoo.com',
  'web.de',
  'gmx.de',
  'outlook.de',
  'yahoo.com.au',
  'gmx.net',
  'googlemail.com',
  'hotmail.fr',
  'mail.com',
  'proton.me',
  'outlook.fr',
  'freenet.de',
  'live.com.au',
  'hotmail.de',
  'yahoo.de',
  'gmx.at',
  'live.com',
  'aol.com',
  'bigpond.com',
  'duck.com',
  'gmail.com.au',
  't-online.de',
  'outlook.com.au',
  'gmx.com',
  'firemail.de',
  'orange.fr',
  'yahoo.fr',
  'live.fr',
  'gmx.ch',
  'yahoo.ca',
  'protonmail.com',
  'hotmail.ca',
  'live.ca',
  'op.pl',
  'mail.ru',
  'msn.com',
  'outlook.co.nz',
  'mail.de',
  'wp.pl',
  'live.de',
  'gmx.fr',
  'y7mail.com',
  'outlook.dk',
  'abv.bg',
  'me.com',
  'interia.pl',
  'hotmail.co.nz',
  'email.com',
  'ymail.com',
  'seznam.cz',
  'eclipso.de',
  'laposte.net',
  'yahoo.co.nz',
  'hotmail.com.au',
  'o2.pl',
  'sfr.fr',
  'inbox.lv',
  'hotmail.co.uk',
  'windowslive.com',
  'yandex.ru',
  'rocketmail.com',
  'live.dk',
  'bluewin.ch',
  'yandex.com',
  'onet.pl',
  'optusnet.com.au',
  'softswiss.com',
  'my.com',
  'free.fr',
  'libero.it',
  'gmail.de',
  'bigpond.net.au',
  'live.no',
];

const MAX_DISTANCE = 2;

const emailPriorityMap = new Map(
  EMAIL_DOMAINS.map((domain, index) => [domain, index])
);

export const correctEmailDomain = (inputValue: string) => {
  const value = inputValue.replace(/@+/, '@').trim().toLowerCase();

  if (!value.includes('@')) return;

  const [inputName, inputDomain] = value.split('@');

  if (!inputName || !inputDomain || EMAIL_DOMAINS.includes(inputDomain)) return;

  const candidates: Array<{ domain: string; distance: number }> = [];
  EMAIL_DOMAINS.forEach((domain) => {
    const distance = findDistance(inputDomain, domain);
    if (distance <= MAX_DISTANCE) {
      candidates.push({ domain, distance });
    }
  });

  if (!candidates.length) return;

  candidates.sort((a, b) => {
    if (a.distance !== b.distance) {
      return a.distance - b.distance;
    }

    return (
      (emailPriorityMap.get(a.domain) ?? 0) -
      (emailPriorityMap.get(b.domain) ?? 0)
    );
  });

  const closestDomain = candidates[0]?.domain;

  if (!closestDomain) return;

  return `${inputName}@${closestDomain}`;
};

export const DOMAINS_OPTIONS = [
  'gmail.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'yahoo.com',
  'gmx.de',
  'outlook.de',
  'gmx.net',
  'hotmail.de',
  'yahoo.de',
  'aol.com',
  'outlook.com.au',
  'gmx.com',
  'yahoo.ca',
  'hotmail.ca',
  'outlook.co.nz',
  'hotmail.co.nz',
  'yahoo.co.nz',
  'hotmail.com.au',
];
